import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import Tooltip from 'components/Tooltip/Tooltip';

import type { IButtonAddPlus } from './interfaces/IButtonAddPlus';

import styles from './sass/ButtonAddPlus.module.scss';

function ButtonAddPlus({
  onClick,
  className,
  disabled,
  hint,
}: IButtonAddPlus) {
  return (
    <Tooltip hint={hint} hintClassName={styles.hint} isDisabled={disabled}>
      <button
        className={`${styles.root} ${className}`}
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        <PlusIcon className={styles.icon} />
      </button>
    </Tooltip>
  );
}

export default ButtonAddPlus;
